/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('select2');
import dt from 'datatables.net-bs4';
require( 'datatables.net-buttons' )();
require( 'datatables.net-buttons-bs4' )();
import $ from 'jquery';
window.$ = window.jQuery = $;

import swal from 'sweetalert';
import store from './store/store';
import VTooltip from 'v-tooltip';

window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.component('create-project', require('./components/CreateProject.vue').default);
Vue.component('project-recipe-card', require('./components/ProjectRecipeCard.vue').default);
Vue.component('pagination-component', require('./components/PaginationComponent.vue').default);
Vue.component('modal-component', require('./components/ModalComponent.vue').default);
Vue.component('data-table', require('./components/DataTable.vue').default);
Vue.component('project-select-recipe', require('./components/ProjectSelectRecipe.vue').default);
Vue.component('title-strip', require('./components/TitleStrip.vue').default);
Vue.component('icon-with-message', require('./components/IconWithMessage.vue').default);
Vue.component('project-recipe-prediction', require('./components/ProjectRecipePrediction.vue').default);
Vue.component('project-recipe-correlation-results', require('./components/ProjectRecipeCorrelationResults.vue').default);
Vue.component('project-recipe-outlier-detection-results', require('./components/ProjectRecipeOutlierDetectionResults.vue').default);
Vue.component('project-fraud-detection-results', require('./components/ProjectFraudDetectionResults.vue').default);
Vue.component('run-recipe-analysis', require('./components/RunRecipeAnalysis.vue').default);
Vue.component('project-results-preview-data', require('./components/ProjectResultsPreviewData.vue').default);

Vue.use(VTooltip);
VTooltip.options.defaultTemplate = '<div class="tooltip-vue" role="tooltip"><div class="tooltip-vue-arrow"></div><div class="tooltip-vue-inner"></div></div>';
VTooltip.options.defaultArrowSelector = '.tooltip-vue-arrow, .tooltip-vue__arrow';
VTooltip.options.defaultInnerSelector = '.tooltip-vue-inner, .tooltip-vue__inner';
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    store: store
});

(function ($) {

    let init = function () {
        listenForUserActionsPopover();
        closeDismissableAlerts();
        initComingSoonAlerts();
        listenForProjectShare();
        changeNavbarBackgroundColorOnScroll();
        initializeDatatables();
    };

    let listenForUserActionsPopover = function () {
        $('[data-toggle="popover"]').popover({
            html: true,
            content: function () {
                return $('#user-actions-popover').html();
            }
        });

        $( document ).on( "click", "#logout-form-action-popover", function(e) {
            e.preventDefault();
            document.getElementById('logout-form').submit();
        });
    };

    let listenForProjectShare = function () {
        $( document ).on( "click", ".share-project-btn", function(e) {
            e.preventDefault();
            const link = $(this).data('link');
            const parentEl = $(this).closest('.parent');
            copyToClipboard(link, parentEl);
        });
    };

    let copyToClipboard = function(str, el) {
        const tempEl = document.createElement('textarea');  // Create a <textarea> element
        tempEl.value = str;                                 // Set its value to the string that you want copied
        tempEl.setAttribute('readonly', '');                // Make it readonly to be tamper-proof
        tempEl.style.position = 'absolute';
        tempEl.style.left = '-9999px';                      // Move outside the screen to make it invisible
        document.body.appendChild(tempEl);                  // Append the <textarea> element to the HTML document
        const selected =
            document.getSelection().rangeCount > 0        // Check if there is any content selected previously
                ? document.getSelection().getRangeAt(0)     // Store selection if found
                : false;                                    // Mark as false to know no selection existed before
        tempEl.select();                                    // Select the <textarea> content
        document.execCommand('copy');                   // Copy - only works as a result of a user action (e.g. click events)
        document.body.removeChild(tempEl);                  // Remove the <textarea> element
        if (selected) {                                 // If a selection existed before copying
            document.getSelection().removeAllRanges();    // Unselect everything on the HTML document
            document.getSelection().addRange(selected);   // Restore the original selection
        }
        el.after('<div class="alert alert-success alert-dismissable">Link copied to clipboard!</div>');
        closeDismissableAlerts();
    };

    let closeDismissableAlerts = function () {
        setTimeout(function () {
            /*Close any flash message after some time*/
            $(".alert-dismissable").fadeTo(4000, 500).slideUp(500, function () {
                $(".alert-dismissable").alert('close');
            });
        }, 3000);
    };

    let initComingSoonAlerts = function () {
        $( document ).on( "click", ".coming-soon-alert", function(e) {
            e.preventDefault();
            swal("Coming soon...", "This will be available shortly. Stay tuned by joining our newsletter!");
        });
    };

    let changeNavbarBackgroundColorOnScroll = function () {
        $(document).scroll(function () {
            const $nav = $("#header-navbar");
            $nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());
        });
    };

    let initializeDatatables = function () {
        $( ".datatable" ).each(function() {
            $( this ).dataTable();
        });
    };

    $(function () {
        $(document).ready(function () {
            init();
        });

    })

})(window.jQuery);
